<template>
  <div class="frame18_body">
    <div class="frame18">
      <div class="frame18_top">
        机构目标价
        <img
          src="../../../../public/img/shares_Info/close.png"
          alt=""
          @click="frame18_close"
        />
      </div>
      <div class="frame18_content">
        <div class="frame18_content_title">机构目标价</div>
        <div class="frame18_content_text">
          【释义】：最近90天内所有机构对该证券未来目标价做出的预测数据的算数平均值，以及最新价到目标均价之间的上涨空间。
        </div>
        <!-- <div class="frame18_content_text">【算法】： 无 </div> -->
        <div class="frame18_content_text">【单位】：元</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  methods: {
    frame18_close() {
      this.$emit("frame18_close");
    },
  },
};
</script>

<style scoped>
.frame18_body {
  width: 100vw;
  height: 100vh;
  position: fixed;
  left: 0;
  top: 0;
  overflow-y: scroll;
  z-index: 9999999;
}
.frame18 {
  width: 448px;
  height: 220px;
  background-color: #ffffff;
  box-shadow: 0px 2px 51px 6px rgba(0, 0, 0, 0.08);
  border-radius: 6px;
  padding: 30px 36px;
  margin: 50px auto;
  margin-top: 200px;
}
.frame18_top {
  width: 100%;
  height: 50px;
  border-bottom: 1px solid #f4f4f4;
  text-align: center;
  font-size: 20px;
  font-weight: bold;
}
.frame18_content {
  margin-top: 28px;
}
.frame18_top img {
  width: 19px;
  float: right;
  margin-top: 3px;
}
.frame18_content_title {
  font-size: 16px;
  font-weight: bold;
  color: #333333;
  line-height: 30px;
}
.frame18_content_text {
  font-size: 16px;
  font-weight: bold;
  color: #666666;
  line-height: 30px;
}
</style>